"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGrid = exports.TAMANHOS_PAGINA = exports.filtrarPorBusca = exports.paraColunaOkton = void 0;
const react_1 = require("react");
const grid_1 = require("./grid");
function mapTipo(tipo) {
    if (tipo === 'numero')
        return 'number';
    if (tipo === 'data')
        return 'date';
    if (tipo === 'texto')
        return 'text';
    return undefined;
}
function paraColunaOkton(coluna) {
    return {
        key: coluna.chave,
        title: coluna.titulo,
        value: coluna.valor,
        type: mapTipo(coluna.tipo),
        align: coluna.alinhamento,
        width: coluna.largura,
        px: coluna.px,
        display: coluna.display,
    };
}
exports.paraColunaOkton = paraColunaOkton;
function filtrarPorBusca(itens, colunas, termo) {
    return (0, grid_1.filterOktonGrid)(itens, colunas.map(paraColunaOkton), termo);
}
exports.filtrarPorBusca = filtrarPorBusca;
exports.TAMANHOS_PAGINA = grid_1.OKTON_PAGE_SIZES;
function useGrid(itens, colunas, busca = '') {
    const colunasOkton = (0, react_1.useMemo)(() => colunas.map(paraColunaOkton), [colunas]);
    const grid = (0, grid_1.useOktonGrid)(itens, colunasOkton, busca);
    return {
        ordenacao: grid.sort
            ? {
                chave: grid.sort.key,
                desc: grid.sort.desc,
            }
            : null,
        alternarOrdenacao: grid.toggleSort,
        itens: grid.items,
        filtrados: grid.filtered,
        pagina: grid.page,
        setPagina: grid.setPage,
        tamanhoPagina: grid.pageSize,
        setTamanhoPagina: grid.setPageSize,
        totalPaginas: grid.pageCount,
    };
}
exports.useGrid = useGrid;
//# sourceMappingURL=compat.js.map